<template>
	<article class="cp" :class="{'xxx': item.xxx}">
		<div class="cp-image-container">
			<!-- image -->
			<figure class="cp-image">
				<NuxtLink :to="item.url_without_domain" class="cp-image-inner" @click="gtmTrack('select_item', {items: item, item_list_id: list?.code || item.category_code, item_list_name: list?.title || item.category_title})">
					<BaseUiImage :loading="props.index && props.index > 4 ? 'lazy' : 'eager'" :data="item.main_image_upload_path_thumb" default="/images/no-image.jpg" :title="item.main_image_title" :alt="item.main_image_description ? item.main_image_description : item.title" width="400" height="400" />
				</NuxtLink>
			</figure>

			<ClientOnly>
				<div class="cp-toolbar">
					<LazyCatalogSetWishlists v-if="userInitialized" :item="item" mode="grid" :list="props.list" />
					<LazyCatalogSetCompare v-if="userInitialized" :item="item" mode="grid" />
				</div>

				<!-- badges -->
				<LazyCatalogProductBadges v-if="userInitialized" :item="item" :types="['image']" class="cp-badges-special" />
				<LazyCatalogProductBadges v-if="userInitialized" :item="item" :types="['energy', 'discount', 'uau', 'uaump', 'condition', 'text']" class="cp-badges" :condition-link="false" :tooltips="true" />
			</ClientOnly>
		</div>

		<div class="cp-cnt">
			<!-- main info -->
			<div class="cp-cnt-top">
				<div class="cp-title">
					<NuxtLink :to="item.url_without_domain" @click="gtmTrack('select_item', {items: item, item_list_id: list?.code || item.category_code, item_list_name: list?.title || item.category_title})">{{ item.title }}</NuxtLink>
				</div>

				<CatalogRates :item="item" />
				<CatalogProductInfo :item="item" />
			</div>

			<div class="cp-cnt-bottom">
				<ClientOnly>
					<LazyCatalogProductPrice v-if="userInitialized" :item="item" class="cp-price" :show-badges="false" />
					<div v-if="installmentPrice" class="cp-price-installment" v-html="labels.get('installments_price_text').replace('%PRICE%', formatCurrency(installmentPrice))"></div>
					<BaseWebshopAddToCart v-slot="{onAddToCart, loading}" v-if="item.is_available && !item.temporary_unavailable && !item.configurable_product_id" :data="{modalData: item, shopping_cart_code: item.shopping_cart_code, quantity: 1}">
						<button class="add btn btn-outline" :class="{'loading': loading}" @click="onAddToCart()" :disabled="loading || (item.xxx && !isAdult)">
							<UiLoader v-if="loading" class="dots dark small" />
							<template v-else>
								<span v-if="item.status == 5"><BaseCmsLabel code="cd_add_to_shopping_cart_preorder" /></span>
								<BaseCmsLabel v-else code='cd_add_to_shopping_cart' tag="span" />
							</template>
						</button>
					</BaseWebshopAddToCart>
					<NuxtLink v-else-if="!item.is_available" :to="item.url_without_domain" class="add btn btn-outline" @click="gtmTrack('select_item', {items: item, item_list_id: list?.code || item.category_code, item_list_name: list?.title || item.category_title})">
						<span><BaseCmsLabel code="read_more" /></span>
					</NuxtLink>
					<NuxtLink v-else-if="item.configurable_product_id" :to="item.url_without_domain" class="add btn btn-outline" @click="gtmTrack('select_item', {items: item, item_list_id: list?.code || item.category_code, item_list_name: list?.title || item.category_title})">
						<span><BaseCmsLabel code="add_to_shopping_cart_configurable" /></span>
					</NuxtLink>
				</ClientOnly>
			</div>
		</div>

		<!-- age verification -->
		<CatalogAgeVerificationOverlay :item="props.item" />
	</article>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['item', 'mode', 'list', 'index']);
	const {formatCurrency} = useCurrency();
	const {installmentPrice, imageBadges} = useProductData(props.item);
	const {openAgeModal, isAdult} = useAgeVerification();
	const {gtmTrack} = useGtmBB();
	const {userInitialized} = useUtils();
</script>

<style lang="less" scoped>
	.cp{
		display: flex; flex-direction: column; background: var(--white); border: 1px solid var(--white); border-radius: var(--borderRadius); position: relative; .transition(border-color); text-align: left;
		@media (min-width: @t){
			&:hover{border-color: var(--blueDark);}
		}
	}
	.cp-toolbar{
		position: absolute; top: 10px; right: 10px; z-index: 5; display: flex; flex-direction: column; gap: 5px;
		@media (max-width: @m){top: 4px; right: 4px;}
	}
	.cp-image-container{
		padding: 20px 14px 16px; border-radius: var(--borderRadius) var(--borderRadius) 0 0; position: relative;
		@media (max-width: @m){padding: 10px 10px 10px;}
	}
	.cp-image{
		display: flex; align-items: center; justify-content: center; width: 100%; position: relative;
		a{
			display: flex; align-items: center; justify-content: center; height: 200px; z-index: 1; width: 100%;
			@media (max-width: @m){height: 150px;}
		}
		:deep(img){display: block; width: auto; height: auto; max-width: 100%; max-height: 100%;}
	}
	.cp-cnt{
		display: flex; flex-direction: column; flex-grow: 1; padding: 0 15px 15px; position: relative;
		@media (max-width: @m){padding: 0 10px 10px;}
	}
	.cp-cnt-top{flex-grow: 1;}
	.cp-cnt-bottom{
		display: flex; flex-direction: column; min-height: 120px; justify-content: flex-end;
		@media (max-width: @m){min-height: 95px;}
	}
	.cp-title{
		display: -webkit-box; text-overflow: ellipsis; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; font-size: 14px; line-height: 1.3; color: var(--black); margin-bottom: 13px;
		a, span {color: var(--black); text-decoration: none; cursor: pointer;}

		@media (max-width: @m){-webkit-line-clamp: 2; font-size: 12px; margin-bottom: 0;}
	}
	@media (max-width: @m){
		:deep(.cp-rate){padding-bottom: 0; padding-top: 7px;}
		.cp-product-info{padding-top: 8px;}
		:deep(.badge){line-height: 1; font-size: 10px; padding: 1px 8px; min-height: 19px;}
		:deep(.old-price){font-size: 11px; padding: 0; width: 100%;}
		:deep(.price-uau){width: 40px; height: 18px; background-size: auto 30px;}
		:deep(.energy){width: auto;}
		:deep(.price){padding-top: 15px;}
	}
	.cp-price{
		:deep(
			.current-price){font-size: 22px;
			@media (max-width: @m){font-size: 15px;}
		}
	}
	.cp-price-installment{
		display: block; margin-top: 1px; font-size: 12px; color: var(--black);
		@media (max-width: @m){font-size: 10px;}
		:deep(strong){font-weight: normal;}
		:deep(p){padding-bottom: 0;}	
	}
	.cp-badges-special{
		position: absolute; top: 14px; left: 16px; z-index: 1; width: 35px;
		:deep(img){display: block;}
		@media (max-width: @m){width: 25px; top: 10px; left: 10px;}
	}
	.add{
		margin-top: 24px; height: 44px;
		@media (max-width: @m){padding: 0; font-size: 13px; height: 35px; margin-top: 15px;}
	}
	/*
	.add{
		position: absolute; font-size: 0; border-radius: 100px; padding: 0; width: 42px; height: 42px; right: 15px; bottom: 15px;
		@media (max-width: @m){width: 30px; height: 30px; bottom: 10px;}
		&:before{.icon-plus(); font: 18px/1 var(--fonti); color: var(--white); }
		&.loading{
			cursor: default; background: var(--blueDark);
			&:before{display: none;}
		}
	}
	*/
	.cp-related{
		:deep(.current-price){font-size: 22px;}
		:deep(.cp-price-installment){font-size: 11px;}
	}
	.cp-badges{
		position: absolute; bottom: 12px; left: 15px; right: 15px; z-index: 1;
		:deep(.badge){
			&:nth-of-type(n + 4){display: none;}
		}
		@media (max-width: @m){bottom: 10px; left: 10px; right: 10px; gap: 3px;}
	}	
</style>
